import{a as i,b as o}from"./chunk-OWBHRN3S.js";import{e as n,m as h}from"./chunk-HBP5N4FR.js";var f,s=n(()=>{h();o();f=e=>{let{hash:t}=i();return t.substring(0,t.indexOf("/")>0?t.indexOf("/"):t.length).replace("#","")===e}});export{f as a,s as b};
//# sourceMappingURL=chunk-JW7ZCUB4.js.map
